import React from "react";
import { Button, Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { contentContainer, titleText, thankYouText, closeButton } from "./styles_vanilla.css";
import { BaseCompletionCardProps } from "./types";

export const BaseCompletionCard = ({ title, onClose }: BaseCompletionCardProps) => {
  return (
    <Flex
      className={contentContainer}
      flexDirection="column"
      alignItems="center"
      gap={Sizes.LG}
    >
      <Icon
        type="check-circle"
        size="xxx-large"
        color={Colors.Success600}
        variant="outline"
        data-testid="success-icon"
      />
      <Flex flexDirection="column" alignItems="center" gap={Sizes.MD}>
        <Text variant="h3" className={titleText}>
          {title}
        </Text>
        <Text variant="regular-md" className={thankYouText}>
          Thank you!
        </Text>
      </Flex>
      <Button variant="primary" className={closeButton} onClick={onClose}>
        Close
      </Button>
    </Flex>
  );
};
